import React from "react";
// import {  CheckSquare } from 'feather-icons-react';
import { Container, Col, Row, Card, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "../../../components/SplitNumber";
import { IconCheckCircle, IconTooman } from "../../../../assets/icons";

function SuccessPaymentWallet(props) {
  return (
    <>
      <Container className="my-auto text-center" style={{ maxWidth: "500px" }}>
        <Card
          className="rounded-4  shadow-sm"
          style={{ border: "1px solid #d2ebe0" }}
        >
          <Card.Header
            className=" very-large-icons border-bottom-0 rounded-top-4 pt-3 pb-4"
            style={{ background: "#e3f9ef" }}
          >
            <IconCheckCircle fillColor="#09a463" />
            <div className="text-success fw-bold fs-103 mt-2">پرداخت موفق</div>
            <div className="text-success mt-1 fs-08">
              پرداخت با موفقیت انجام شد.
            </div>
          </Card.Header>
          <Card.Body>
            <Row className=" mt-3 mb-4">
              <Col xs="12" className="fs-09">
                شما اکنون مبلغ{" "}
                <span className="fs-101 fw-bold">
                  <SplitNumber number={props.amount}></SplitNumber>
                </span>
                <span className="px-1 d-inline-block">تومان</span>
                <span className="fw-bold ps-1"> پرداخت کردید.</span>
              </Col>
            </Row>
            <Row className=" py-1 fs-085">
              <Col xs="auto">شماره پیگیری</Col>
              <Col className="my-auto opacity-10 px-0">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col xs="auto" className="fw-bold">
                {props.referenceId}
              </Col>
            </Row>
            <Row className=" py-3 fs-085">
              <Col xs="auto"> موجودی کیف پول</Col>
              <Col className="my-auto opacity-10 px-0">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col xs="auto" className="fw-bold">
                <SplitNumber
                  number={props.userWalletRiallBalance}
                ></SplitNumber>{" "}
                <IconTooman style={{ marginTop: "-12px" }} />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default SuccessPaymentWallet;
